import React, { useState } from "react";
import api from "../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import localforage from "localforage";
import logo from "../assets/akar-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleUpdatePassword = () => {
    navigate("/update");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await api.post(`${API_URL}/auth/login`, {
        email,
        password,
      });

      const userObj = response.data.userObj;
      const userEmail = userObj.email;
      const userName = userObj.userName;
      const token = response.data.token;
      const id = userObj._id;
      const roles = userObj.roles;
      const role = roles[0];
      const role1 = roles[1] || "";
      const empId = userObj.empId || "";
      const location = userObj.location;
      const stcCode = userObj.stcCode;

      await Promise.all([
        localforage.setItem("userName", userName),
        localforage.setItem("email", userEmail),
        localforage.setItem("token", token),
        localforage.setItem("ID", id),
        localforage.setItem("role", role),
        localforage.setItem("role1", role1),
        localforage.setItem("empId", empId),
        localforage.setItem("stcCode", stcCode),
        localforage.setItem("roles", roles),
        localforage.setItem("location", location),
      ]);

      navigate("/welcome");
      window.location.reload();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setError("Incorrect email or password");
      } else {
        setError("Login failed. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={logo} className="login-logo" alt="Akar Logo" />
        <h1 className="login-title">Sign In</h1>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-input-group">
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
              disabled={isLoading}
            />
          </div>

          <div className="login-input-group password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
              disabled={isLoading}
            />
            <div
              className="password-toggle-icon"
              onClick={toggleShowPassword}
            >
              <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
            </div>
          </div>

          {error && <p className="login-error">{error}</p>}

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <button 
          onClick={handleUpdatePassword} 
          className="login-secondary-button"
          disabled={isLoading}
        >
          Update Password
        </button>
      </div>
    </div>
  );
};

export default Login;
